import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

import PageHeader from '@/components/layout/page-header'
import CreateDriverForm from '@/features/drivers/components/create-driver-form'
import { useDocumentTitle } from '@/hooks/use-document-title'
import { localizedPageTitle } from '@/lib/page-title'

export const Route = createFileRoute('/dashboard/drivers/create')({
  head: () => ({ meta: [{ title: localizedPageTitle('addDriver') }] }),
  component: RouteComponent,
})

function RouteComponent() {
  useDocumentTitle('addDriver')
  const { t } = useTranslation('drivers')

  return (
    <div className="mx-auto max-w-6xl space-y-4 pb-4">
      <PageHeader title={t('addNewDriver')} subtitle={t('enterDriverInfo')} />

      <CreateDriverForm />
    </div>
  )
}
